import { render } from "./BarcodeLinkScan.vue?vue&type=template&id=71e254a6&scoped=true"
import script from "./BarcodeLinkScan.vue?vue&type=script&lang=ts"
export * from "./BarcodeLinkScan.vue?vue&type=script&lang=ts"

import "./BarcodeLinkScan.vue?vue&type=style&index=0&id=71e254a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71e254a6"

export default script